var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58887 12.4111 0 8 0ZM14.5238 4.66666H11.0376C10.7228 2.97953 10.1741 1.62431 9.48375 0.817906C11.6858 1.27219 13.5249 2.71969 14.5238 4.66666ZM10.6667 8C10.6667 8.96163 10.594 9.85353 10.4719 10.6667H5.52806C5.40594 9.8535 5.33331 8.96163 5.33331 8C5.33331 7.03837 5.40594 6.14647 5.52806 5.33334H10.4719C10.594 6.1465 10.6667 7.03837 10.6667 8ZM8 0.666656C8.90166 0.666656 9.87397 2.21059 10.3569 4.66666H5.64309C6.12603 2.21062 7.09834 0.666656 8 0.666656ZM6.51625 0.817906C5.82594 1.62431 5.27725 2.97953 4.96241 4.66666H1.47619C2.47512 2.71969 4.31422 1.27219 6.51625 0.817906ZM0.666656 8C0.666656 7.05856 0.851313 6.16106 1.17597 5.33334H4.85344C4.73441 6.16522 4.66666 7.05919 4.66666 8C4.66666 8.94081 4.73441 9.83481 4.85344 10.6667H1.176C0.851313 9.83894 0.666656 8.94144 0.666656 8ZM1.47619 11.3333H4.96241C5.27722 13.0205 5.82594 14.3757 6.51625 15.1821C4.31422 14.7278 2.47512 13.2803 1.47619 11.3333ZM8 15.3333C7.09834 15.3333 6.12603 13.7893 5.64309 11.3333H10.3569C9.87397 13.7893 8.90166 15.3333 8 15.3333ZM9.48375 15.1821C10.1741 14.3757 10.7227 13.0205 11.0376 11.3333H14.5238C13.5249 13.2803 11.6858 14.7278 9.48375 15.1821ZM11.1466 10.6667C11.2656 9.83478 11.3333 8.94081 11.3333 8C11.3333 7.05919 11.2656 6.16519 11.1466 5.33334H14.824C15.1487 6.16106 15.3333 7.05856 15.3333 8C15.3333 8.94144 15.1487 9.83894 14.824 10.6667H11.1466Z",
    fill: "#1D1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.880c2393bbe577ea2cadd11642be980b.svg";
export { ForwardRef as ReactComponent };